<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <AreaTable />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import AreaTable from "./components/AreaTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    AreaTable,
    // ProjectsTable,
  },
};
</script>
